import styled from 'styled-components';
import { StyledPopupWidgetCon, StyledProductItemCon } from '../../../../skins';

export const StyledCentralFullpagePopupWidgetCon = styled(StyledPopupWidgetCon)`
  max-height: 550px;

  & .mr-popup-widget__products-container {
    margin: -1px 0px;
  }
`;

export const StyledCentralFullpageProductItemCon = styled(StyledProductItemCon)`
  & .mr-product-item__body {
    justify-content: start;
  }

  & .mr-product-item__actions--vertical-full-width {
    max-width: 375px;
  }
`;
